import { render, staticRenderFns } from "./ImportLead.vue?vue&type=template&id=15b4329a&scoped=true"
import script from "./ImportLead.vue?vue&type=script&lang=js"
export * from "./ImportLead.vue?vue&type=script&lang=js"
import style0 from "./ImportLead.vue?vue&type=style&index=0&id=15b4329a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4329a",
  null
  
)

export default component.exports